import { getDocumentsListAPI } from "../sevices/listDocumentsService";

export const getDocumentsList = () => (dispatch) => {
    dispatch(getDocumentsListAPI());
}